var _circle, _ellipse, _line, _line2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDnsZonesHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "url(#g1_dnz_h)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 10,
    rx: 3.5,
    ry: 8,
    stroke: "#BDCEEE",
    strokeWidth: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 10,
    x2: 18,
    y2: 10,
    stroke: "#BDCEEE",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 2,
    x2: 10,
    y2: 18,
    stroke: "#BDCEEE",
    strokeWidth: 1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1_dnz_h",
    x1: 10,
    y1: 2,
    x2: 10,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnsZonesHover);
export default __webpack_public_path__ + "static/media/dns-zones-hover.df1ac2933020c4ef3beb0aa91f9e4eef.svg";
export { ForwardRef as ReactComponent };